// The UI shell's root (IMPLEMENTATION §2.1 ui/App.tsx, §2.6 layer model, UX §0 / §2 screen map). Inside #ui
// (z 2–4 of the page stack) the chrome sits in this order, each part in its layout rect:
//   chrome   HUD · goal chip / Build banner · counter / Build bar · tab bar     (z-index 0 inside #ui)
//   board    the rule / completion banner, the how-to card, the ⟳ handle          (1)
//   panels   Shop sheet (+ pop-over), cards, goal card, Settings              (2; the tab bar stays above: 3)
//   toasts   ≤ 2 above the counter or the open panel                          (4)
// The DOM FX layer (#fx, z 50: drag ghost, bubbles, hint finger, M10 coins / floaters), the splash (z 100) and
// the blocking overlays (#overlay, z 200: ErrorScreen, context lost, Elsewhere, RotateOverlay, the A2HS card)
// sit above; see ui/overlays/mount.tsx. Under the chrome, the column frame dims the board canvas outside the
// column (a wide desktop window shows the mine round it, not a bare page).
import { CardPanel } from './cards/Cards.tsx';
import { HowToCard, RotateHandle, RuleBanner } from './components/Banners.tsx';
import { BuildBar, TabBar } from './components/Bars.tsx';
import { box } from './components/box.ts';
import { CounterBar } from './components/Counter.tsx';
import { GoalCard, GoalChip } from './components/GoalChip.tsx';
import { Hud } from './components/Hud.tsx';
import { SettingsSheet } from './components/Settings.tsx';
import { ShopSheet } from './components/ShopSheet.tsx';
import { Toasts } from './components/Toasts.tsx';
import { SpikePanel } from './SpikePanel.tsx';
import { layoutSig, modeSig } from './state.ts';

export function App() {
  const l = layoutSig.value;
  if (!l) return null;
  const build = modeSig.value?.mode === 'build';
  return (
    <div class={`shell cls-${l.cls}`} data-testid="shell" data-cls={l.cls}>
      <div class="column-frame" style={box(l.column)} aria-hidden="true" />
      <Hud />
      <GoalChip />
      {build ? <BuildBar /> : <CounterBar />}
      <RuleBanner />
      <HowToCard />
      <RotateHandle />
      <ShopSheet />
      <CardPanel />
      <GoalCard />
      <SettingsSheet />
      <TabBar />
      <Toasts />
      <SpikePanel />
    </div>
  );
}
